import { useQueryClient } from '@tanstack/react-query';
import useApiMutation from '_api/mutations/useApiMutation';
import { GET_PATIENT_GOALS } from '_api/queries/goal/useGetPatientGoals';
import { Goal, GoalPayload } from '_api/types';

export const EDIT_GOAL = 'edit-goal';

export const useEditGoal = () => {
  const queryClient = useQueryClient();
  return useApiMutation<Goal, GoalPayload>(
    () => '/goal',
    'put',
    {},
    {
      mutationKey: [EDIT_GOAL],
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: [GET_PATIENT_GOALS] });
      },
    },
  );
};
